export default [{
        path: '/billConfirm',
        name: 'billConfirm',
        component: () =>
            import ( /* webpackChunkName: "billConfirm" */ "@/pages/billConfirm/index.vue"),
        meta: {
            title: '确认账单'
        }
    },
    {
        path: '/billElectronicSignature',
        name: 'billElectronicSignature',
        component: () =>
            import ( /* webpackChunkName: "billElectronicSignature" */ "@/pages/billConfirm/billElectronicSignature.vue"),
        meta: {
            title: '确认账单电子签'
        }
    },
]